import {Component, OnInit, Input, ViewChild, ElementRef, Output, EventEmitter, OnDestroy } from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {WarningComponent} from 'src/app/shared/components/warning/warning.component';
import {CommonService} from 'src/app/core/services/common.service';
import {Message} from 'src/app/core/class/message';
import {ToastrService} from 'ngx-toastr';
import {DocumentService} from 'src/app/core/services/document.service';
import {iOutChangingStat} from 'src/app/core/interfaces/common';
import FileUtils, {ContentType} from 'src/app/core/services/file-utils';
import {DataService} from '../../../core/services/data.service';

@Component({
  selector: 'app-upload-file',
  templateUrl: './upload-file.component.html',
  styleUrls: ['./upload-file.component.scss']
})
export class UploadFileComponent implements OnInit, iOutChangingStat, OnDestroy  {
  // refresh input file
  @ViewChild('inputUpload', {read: '', static: false}) inputUploadFile: ElementRef;

  // share data from arr attchment when call method get view detail
  @Input() arrAttachments: any[];

  // share data from arr attchment of customer in screen add-document
  @Input() arrAttachmenstOfCustomer: any[];

  // check for view detail
  @Input() isViewDetail: boolean;

  // check for view detail
  @Input() isCustomer: boolean;

  // check for view detail
  @Input() isAttachFileForDocument: boolean;

  @Input() isUser: boolean;

  // Let parent component this changing status
  @Output() hasChange: EventEmitter<boolean> = new EventEmitter();

  public hasOverride = false;

  public haveErrorResult = false;

  // array file
  listFile: any[] = [];

  // check max size
  maxSizeInput = false;

  // check form changing
  isFormChanging = false;

  private subscribeDownFile: any;
  private subscribeHaveErrorResult: any;

  /**
   * Check format type file
   */
  errorFormatTypeFile = false;

  acceptContentType: ContentType[] = [ContentType.UNKNOWN];

  resultImportExcelName: any;

  dataUploadFile: any;

  constructor(
    public dialog: MatDialog,
    private commonService: CommonService,
    private documentService: DocumentService,
    private message: Message,
    private toastr: ToastrService,
    private dataService: DataService
  ) {
  }

  ngOnInit() {
    if (this.arrAttachments === undefined) {
      this.arrAttachments = [];
    }

    this.subscribeHaveErrorResult = this.dataService.haveErrorResult.subscribe({
      next: (v) => {
        this.haveErrorResult = v;
      }
    });

    this.subscribeDownFile = this.dataService.downFile.subscribe({
      next: (v) => {
        if (this.isCustomer && this.isCustomer !== undefined) {
          this.commonService.downFileTemplateExcelAddCustomer().subscribe(rs => {
            this.downLoadFile(rs, 'application/octet-stream', 'Template_import_customer.xlsx');
          });
        } else if (this.isUser && this.isUser !== undefined) {
          this.commonService.downFileTemplateExcelAddUser().subscribe(rs => {
            this.downLoadFile(rs, 'application/octet-stream', 'Template_import_user.xlsx');
          })
        }
      }
    });
  }

  ngOnDestroy() {
    this.subscribeDownFile.unsubscribe();
    this.subscribeHaveErrorResult.unsubscribe();
  }

  downResultImport(e) {
    e.preventDefault();
    if (this.isCustomer) {
      this.commonService.downResultImportExcelAddCustomer(this.resultImportExcelName).subscribe(rs => {
        // this.dataService.setHaveErrorResult(false);
        this.dataService.setImported(true);
        this.downLoadFile(rs, 'application/octet-stream', this.resultImportExcelName);
      });
    }
    if (this.isUser) {
      this.commonService.downResultImportExcelAddUser(this.resultImportExcelName).subscribe(rs => {
        this.dataService.setImported(true);
        this.downLoadFile(rs, 'application/octet-stream', this.resultImportExcelName);
      });
    }
  }

  // get file from selected file
  async getFiles(e) {
    const attachLengthBeforeUpload: number = this.arrAttachments.length;
    this.maxSizeInput = false;
    this.errorFormatTypeFile = false;

    // simple check mime-type based on file extension
    if (!this.checkFormatTypeFile(e.target.files)) {
      // Check file size of list file when selected upload
      if (!this.totalSize(e.target.files)) {
        await this.checkContentTypeThenAddToList(e.target.files);
      }
    }
    this.dataService.setHaveErrorResult(false);

    this.reset();
    const hasSucceedFile = this.arrAttachments.length > attachLengthBeforeUpload;
    if (hasSucceedFile) {
      this.setFormChanging(true);
    }
  }

  private async checkContentTypeThenAddToList(files: File[]): Promise<boolean> {
    let r = true;
    await this.checkContentTypeFile(files).then(rs => {
      r = rs;
      if (rs) {
        this.addToList(files);
      }
    });
    return new Promise((resolve, reject) => resolve(r));
  }

  private async checkContentTypeFile(files: File[]): Promise<boolean> {
    let r = true;
    for (const file of files) {
      const ct: ContentType = await FileUtils.getContentType(file);
      if (!this.acceptContentType.includes(ct)) {
        this.errorFormatTypeFile = true;
        r = false;
        break;
      }
    }
    return new Promise((resolve, reject) => resolve(r));
  }

  private addToList(files: File[]) {
    const duplicateFile: File[] = [];
    this.arrAttachments = [];
    for (const file of files) {
      if (this.arrAttachments.length > 0) {
        let check = false;
        for (let j = 0; j < this.arrAttachments.length; j++) {
          if (this.arrAttachments[j].fileName !== undefined) {
            if (file.name === this.arrAttachments[j].fileName) {
              check = true;
              duplicateFile.push(file);
            }
          } else {
            if (file.name === this.arrAttachments[j].name) {
              check = true;
              duplicateFile.push(file);
            }
          }
        }
        if (!check) {
          this.dataService.setHaveAttachFile(true);
          this.arrAttachments.push(file);
        }
      } else {
        this.dataService.setHaveAttachFile(true);
        this.arrAttachments.push(file);
      }
    }
    if (duplicateFile !== undefined && duplicateFile.length > 0) {
      this.showDialog(duplicateFile)
        .afterClosed()
        .subscribe(rs => {
          if (rs) {
            this.overriedDuplicated(this.arrAttachments, duplicateFile);
            this.hasOverride = true;
            this.setFormChanging(true);
          }
        });
    }
  }

  /**
   * Check type file when upload ( Accept file img and pdf )
   */
  checkFormatTypeFile(files): boolean {
    for (let i = 0; i < files.length; i++) {
      if (files[i].type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
        this.errorFormatTypeFile = true;
      }
    }

    if (this.errorFormatTypeFile) {
      return true;
    } else {
      return false;
    }
  }

  // overried file duplicated
  private overriedDuplicated(arrAttach, duplicateFile) {
    duplicateFile = duplicateFile.filter((v, i, a) => a.indexOf(v) === i);
    // console.log(arrAttach);
    // console.log(duplicateFile);
    const dupList = [];
    const pushList = [];
    for (let i = 0; i < arrAttach.length; i++) {
      for (let j = 0; j < duplicateFile.length; j++) {
        if ((arrAttach[i].fileName !== undefined && duplicateFile[j].name === arrAttach[i].fileName) || (arrAttach[i].fileName === undefined && duplicateFile[j].name === arrAttach[i].name)) {
          dupList.push(arrAttach[i]);
          pushList.push(duplicateFile[j]);
        }
      }
    }

    // console.log(dupList);
    // console.log(pushList);
    dupList.forEach(x => {
      arrAttach.splice(arrAttach.indexOf(x), 1);
    });
    pushList.forEach(x => {
      arrAttach.push(x);
    });
    this.reset();
  }

  // check total max size for all file attachment
  private totalSize(files): boolean {
    let totalSize = 0;

    // List arrAttachments include file old and file new when selected upload
    this.arrAttachments.forEach(attach => {
      if (attach.fileSize !== undefined) {
        totalSize = totalSize + attach.fileSize;
      } else {
        totalSize = totalSize + attach.size;
      }
    });

    for (let i = 0; i < files.length; i++) {
      totalSize = totalSize + files[i].size;
    }

    if (totalSize > 10485760) {
      this.maxSizeInput = true;
      return true;
    } else {
      return false;
    }
  }

  // upload multi file
  uploadFile(successCallback: () => void, noUpload: () => void) {
    const fileUpload = this.arrAttachments.filter(
      arrAttachments => arrAttachments.name !== undefined);
    if (fileUpload.length > 0) {
        if (this.isCustomer) {
          this.uploadCustomer(fileUpload);
        } else if (this.isUser) {
          this.uploadUser(fileUpload);
        }
    } else {
      noUpload();
    }
    console.log(fileUpload);
    
  }

  uploadCustomer(fileUpload: any) {
    const date = this.dateToString(new Date());
    const userName = localStorage.getItem('userName');
    const random = this.randomStr(5);
    if (date) {
      this.resultImportExcelName = 'Template_import_file_result' + '_' + userName + '_' + date + '_' + random + '.xlsx';
    } else {
      this.resultImportExcelName = 'Template_import_file_result.xlsx';
    }
    this.commonService.uploadAddCustomerFromExcel(fileUpload, this.resultImportExcelName)
      .subscribe(rs => {
        if (rs.code === 'IMPORTED_EXCEL_LIST_CUSTOMER_ERROR') {
          this.dataService.setHaveErrorResult(true);
        } else if (rs.code === 'IMPORTED_EXCEL_LIST_CUSTOMER') {
          this.dataService.setHaveErrorResult(false);
          this.dataService.setImported(true);
          this.toastr.success(rs.message);
        } else if (rs.code === '0x002017' || rs.code === '0x002018') {
          this.dataService.setHaveErrorResult(false);
          this.dataService.setImported(true);
          this.toastr.error(rs.message);
        }
        this.arrAttachments = [];
        this.dataService.setHaveAttachFile(false);
      });
  }

  uploadUser(fileUpload: any) {
    this.commonService.uploadAddUserFromExcel(fileUpload, this.resultImportExcelName)
      .subscribe(rs => {
        if (rs.code === 'IMPORTED_EXCEL_LIST_USER') {
          this.resultImportExcelName = rs.data.fileName;
          this.dataUploadFile = rs;
          this.dataService.setHaveErrorResult(true);
        } else if (rs.code === '0x003001' || rs.code === '0x003002') {
          this.dataService.setHaveErrorResult(false);
          this.dataService.setImported(true);
          this.toastr.error(rs.message);
        }
        this.arrAttachments = [];
        this.dataService.setHaveAttachFile(false);
      });
  }

  // after upload success
  private uploadFileSuccess(rs, successCallback: (data) => void) {
    for (let i = 0; i < rs.data.length; i++) {
      this.arrAttachments.push(rs.data[i]);
    }

    this.arrAttachments = this.arrAttachments.filter(
      arrAttachments => arrAttachments.fileName !== undefined);

    successCallback(this.arrAttachments);
  }

  // remove file from arr listFile for arr file add
  deleteFile(item) {
    this.maxSizeInput = false;
    let totalSize = 0;

    const dialogRef = this.dialog.open(WarningComponent, {
      width: '350px',
      data: this.message.getMessage('popup.confirm_delete_file')
    });
    dialogRef.afterClosed().subscribe(rs => {
      if (rs) {
        const index = this.arrAttachments.indexOf(item);
        if (index > -1) {
          this.arrAttachments.splice(index, 1);
        }

        this.toastr.success(this.message.getMessage('messages.delete_success'));

        const arrAttachments = this.arrAttachments.filter(
          arrAttachment => arrAttachment.name !== undefined);

        arrAttachments.forEach(element => {
          totalSize += element.size;
        });

        this.dataService.setHaveAttachFile(false);
        this.totalSize(totalSize);
        this.setFormChanging(true);
        this.reset();
      }
    });
  }

  // show dialog file duplicated
  private showDialog(duplicateFile) {
    let code = '<ul>';

    for (let i = 0; i < duplicateFile.length; i++) {
      if (duplicateFile[i].name !== undefined) {
        code += '<li>' + duplicateFile[i].name + '</li>';
      } else {
        code += '<li>' + duplicateFile[i].fileName + '</li>';
      }
    }

    code += '</ul>';

    const dialogRef = this.dialog.open(WarningComponent, {
      width: '430px',
      data: this.message.getMessage('popup.confirm_override_file') + code,
    });

    return dialogRef;
  }


  // refresh input
  private reset() {
    this.inputUploadFile.nativeElement.value = '';
  }

  /**
   * Download file.
   * @param path the encrypt path.
   * @param fileName file name of file.
   */
  donwloadUrl(id: string, fileName: string) {
    if (this.isCustomer && this.isCustomer !== undefined) {
      return this.commonService.downloadFileCustomer(id).subscribe(
        rs => {
          this.downLoadFile(rs, 'application/octet-stream', fileName);
        }
      );
    } else {
      return this.commonService.downloadFileEnterprises(id).subscribe(
        rs => {
          this.downLoadFile(rs, 'application/octet-stream', fileName);
        }
      );
    }
  }

  /**
   * Method is use to download file.
   * @param data - Array Buffer data
   * @param type - type of the document.
   * @param fileName - file name of file
   */
  downLoadFile(data: any, type: string, fileName: string) {
    const blob = new Blob([data], {type});
    if (window.top.navigator.msSaveOrOpenBlob) {
      // Store Blob in IE
      window.top.navigator.msSaveOrOpenBlob(blob, fileName);
    } else {
      // Store Blob in others
      const tA = document.body.appendChild(document.createElement('a'));
      tA.href = URL.createObjectURL(blob);
      tA.download = fileName;
      tA.style.display = 'none';
      tA.click();
      tA.parentNode.removeChild(tA);
    }
  }

  /**
   * Update changing status and share with other component.
   */
  setFormChanging(changingStatus: boolean) {
    this.isFormChanging = changingStatus;
    this.hasChange.emit(changingStatus);
  }

  dateToString(date: Date) {
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const yyyy = date.getFullYear();
    // let hour = String(date.getHours()).padStart(2, '0');
    // let minutes = String(date.getMinutes()).padStart(2, '0');
    // let seconds = String(date.getSeconds()).padStart(2, '0');
    // return yyyy + mm + dd + hour + minutes + seconds;
    return yyyy + mm + dd;
  }

  randomStr(length) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() *
        charactersLength));
    }
    return result;
  }
}
